import { useGetActiveMaintenanceNotificationsQuery } from 'store/api/maintenanceNotifications';

const MaintenanceIndicatorBar = () => {
    const {
        data: notifications,
        isLoading,
        isError,
    } = useGetActiveMaintenanceNotificationsQuery(undefined, { pollingInterval: 900000 });

    if (isLoading || isError || !notifications || notifications.length === 0) {
        return null;
    }

    return (
        <>
            {notifications.map((maintenance) => (
                <div
                    key={`${maintenance.fromTime}-${maintenance.untilTime}`}
                    className="flex min-h-9.5 w-full items-center justify-center gap-2.5 p-2 font-bold whitespace-pre-line"
                    // The colours are the notice's own, set by whoever scheduled it.
                    style={{ backgroundColor: maintenance.backgroundColor, color: maintenance.textColor }}
                >
                    <p>{maintenance.maintenanceMessage}</p>
                </div>
            ))}
        </>
    );
};

export default MaintenanceIndicatorBar;
